import React from 'react'

import Button from '@react/react-spectrum/Button'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Heading from '@react/react-spectrum/Heading'
import Help from '@react/react-spectrum/Icon/Help'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Tooltip from '@react/react-spectrum/Tooltip'

import LocalePicker from 'components/LocalePicker'
import TranslateDialog from 'components/TranslateDialog/TranslateDialog'

export function CustomerHubSettings({ settings, disabled, onChange }) {
  const _onChange = (propName) => (v) => !disabled && onChange(propName)(v)

  return (
    <>
      <section>
        <Heading size='4'>General</Heading>

        <FieldLabel label='Locale' labelFor='locale'>
          <LocalePicker value={settings.locale} onChange={_onChange('locale')} disabled={disabled} />
          <OverlayTrigger placement='right'>
            <Button className='tooltip-btn' variant='tool' icon={<Help />} />
            <Tooltip>
              Select or type in language/currency locale. Delete field content to see the full list of common options.
            </Tooltip>
          </OverlayTrigger>
        </FieldLabel>
      </section>

      <section>
        <Heading size='4'>Translation</Heading>
        <p style={{ margin: '0 0 12px', color: '#6e6e6e', fontSize: 13 }}>
          Translate all visible project content to another language.
        </p>
        {settings.id && <TranslateDialog projectId={settings.id} disabled={disabled} currentLanguage={settings.language} />}
      </section>
    </>
  )
}
